import React from "react";
import { useState } from "react";

import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import Features from "components/features/ThreeColSimple.js";
import MainFeature from "components/features/TwoColWithButton.js";
import MainFeature2 from "components/features/TwoColSingleFeatureWithStats2.js";
import TabGrid from "components/cards/TabCardGrid.js";
import Testimonial from "components/testimonials/ThreeColumnWithProfileImage.js";
import DownloadApp from "components/cta/DownloadApp.js";
import { SectionHeading } from "components/misc/Headings";
import MessageAnimation from "./MessageAnimation";

import chefIconImageSrc from "images/chef-icon.svg";
import celebrationIconImageSrc from "images/celebration-icon.svg";
import shopIconImageSrc from "images/shop-icon.svg";
import heroImageSrc from "images/IMPOTS REDUC - Percevez des revenus complémentaires défiscalisés.webp";
import anacofiImageSrc from "images/anacofi-logo-02.webp";
import oriasImageSrc from "images/orais-logo.webp";
import defiscaliserImageSrc from "images/Contactez un expert partenaire d'Impôts Réduc et bénéficiez d'une consultation fiscale gratuite et sans engagement.webp";

export default () => {
  const Subheading = tw.span`tracking-wider text-sm font-medium`;
  const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 transform -skew-x-12 inline-block`;
  const HighlightedTextInverse = tw.span`bg-gray-100 text-primary-500 px-4 transform -skew-x-12 inline-block`;
  const Description = tw.span`inline-block mt-8`;
  const imageCss = tw`rounded-4xl xl:w-[40vw] xl:h-[32vw] self-end`;

  const [isValidNumber, setIsValidNumber] = useState(true);
  const [hasSentPhone, setHasSentPhone] = useState(false);


  return (
    <AnimationRevealPage>
      <Hero
        heading={<>Vos revenus complémentaires <HighlightedText>Sans payer d’impôts !</HighlightedText></>}
        description={<p tw="text-base">Il existe de nombreux dispositifs légaux qui permettent de percevoir des revenus complémentaires <b>défiscalisés et de façon récurrente.</b> <br />
        Ces dispositifs sont <b>accessibles à tous</b>, que vous payiez ou non des impôts, et <b>sans aucun apport personnel</b> dans certains cas.</p>}
        imageSrc={heroImageSrc}
        imageCss={imageCss}
        imageDecoratorBlob={true}
        primaryButtonText="Appeler maintenant"
        primaryButtonUrl="#appelle-moi"
        ctaText="Testez gratuitement votre éligibilité avec un Expert fiscal en appelant "
      />

      <Testimonial
        subheading=""
        heading={<>Ils recommandent <HighlightedText>Impôts Réduc’</HighlightedText></>}
      />
      {/* <MainFeature
        subheading={<Subheading>Established Since 2014</Subheading>}
        heading={
          <>
            We've been serving for
            <wbr /> <HighlightedText>over 5 years.</HighlightedText>
          </>
        }
        description={
          <Description>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
            dolore magna aliqua.
            <br />
            <br />
            Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
          </Description>
        }
        buttonRounded={false}
        textOnLeft={false}
        primaryButtonText="Latest Offers"
        imageSrc={
          "https://images.unsplash.com/photo-1460306855393-0410f61241c7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=768&q=80"
        }
        imageCss={imageCss}
        imageDecoratorBlob={true}
        imageDecoratorBlobCss={tw`left-1/2 -translate-x-1/2 md:w-32 md:h-32 opacity-25`}
      /> */}
      {/* TabGrid Component also accepts a tabs prop to customize the tabs and its content directly. Please open the TabGrid component file to see the structure of the tabs props.*/}



      {/* <Features
        heading={
          <>
            Amazing <HighlightedText>Services.</HighlightedText>
          </>
        }
        cards={[
          {
            imageSrc: shopIconImageSrc,
            title: "230+ Locations",
            description: "Lorem ipsum donor amet siti ceali placeholder text",
            url: "https://google.com"
          },
          {
            imageSrc: chefIconImageSrc,
            title: "Professional Chefs",
            description: "Lorem ipsum donor amet siti ceali placeholder text",
            url: "https://timerse.com"
          },
          {
            imageSrc: celebrationIconImageSrc,
            title: "Birthday Catering",
            description: "Lorem ipsum donor amet siti ceali placeholder text",
            url: "https://reddit.com"
          }
        ]}

        imageContainerCss={tw`p-2!`}
        imageCss={tw`w-20! h-20!`}
      /> */}
      <section id="appelle-moi">
      <MainFeature2
        subheading={<Subheading>Experts en économies d’impôts</Subheading>}
        heading={<>Défiscalisez <HighlightedText>dès maintenant !</HighlightedText></>}
        textOnLeft={false}
        statistics={[
          {
            key: "Mises en relation depuis 2020",
            value: "+40000",
          },
          {
            key: "Tous les dispositifs légaux",
            value: "100%"
          },
          {
            key: "D’économies d’impôts en moyenne",
            value: "2500 €/AN"
          }
        ]}
        description={<div>
          <p>Contactez-nous pour bénéficier d’une <b>consultation fiscale gratuite avec un expert certifié</b> par l’Autorité des marchés financiers (AMF). <b>Ce service est anonyme et sans engagement.</b></p>
          
        </div>}
        button={<div>
            {!hasSentPhone && <form tw="mt-5" 
            action="https://formsubmit.co/contact@impots-reduc.fr" 
            method="POST" 
            id="formulaire-appelle-moi"
            onSubmit={(e) => {
               e.preventDefault();
                const phoneNumber = e.target.querySelector('input[type="tel"]').value.trim();
                const errorMessage = document.getElementById('error-message');
                const submitButton = document.getElementById('submit-button');

                // Validation on submit
                if (!phoneNumber) {
                  errorMessage.textContent = 'Veuillez saisir votre numéro de téléphone';
                  e.target.querySelector('input[type="tel"]').style.border = '2px solid #EF4444';
                  submitButton.disabled = true;
                  return;
                }

                // If validation passes, submit the form
                fetch("https://formsubmit.co/ajax/contact@impots-reduc.fr", {
                method: "POST",
                headers: { 
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    "Numéro de téléphone": phoneNumber
                })
            })
                .then(response => response.json())
                .then(data => console.log(data))
                .catch(error => console.log(error));
                setHasSentPhone(true);

              // trigger event for google tags tracking
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                'event': 'phone_number_submission'
              });

                // e.target.submit();
            }}
            >
              <input type="hidden" name="_template" value="box"></input>
              <input type="hidden" name="_captcha" value="false"></input>
              <input type="hidden" name="_subject" value="Appelez moi!"></input>
              <div tw="flex h-16 gap-3 items-center">
                <input 
                  type="tel" 
                  name="Numéro de téléphone" 
                  inputmode="numeric"
                  placeholder="Votre numéro de téléphone"
                  tw={"w-full px-8 py-4 rounded-lg font-medium bg-gray-100 border border-green-500  border-2 placeholder-gray-500 text-sm focus:outline-none focus:border-green-400 focus:bg-white mt-5 first:mt-0 max-sm:text-xs max-sm:px-2"}
                  onChange={(e) => {
                    const phoneNumber = e.target.value.trim().replaceAll(" ", "");
                    const errorMessage = document.getElementById('error-message');
                    const submitButton = document.getElementById('submit-button');
                    setIsValidNumber(false);

                    // Reset styles
                    e.target.style.border = '';
                    errorMessage.textContent = '';

                    // Validation
                    if (!phoneNumber) {
                      e.target.style.border = '2px solid #EF4444';
                      errorMessage.textContent = 'Veuillez saisir votre numéro de téléphone';
                      return;
                    }

                    // Check if starts with 0
                    if (!phoneNumber.startsWith('0')) {
                      e.target.style.border = '2px solid #EF4444';
                      errorMessage.textContent = 'Le numéro doit commencer par 0';
                      return;
                    }

                    // Check if contains only numbers
                    if (!/^\d+$/.test(phoneNumber)) {
                      e.target.style.border = '2px solid #EF4444';
                      errorMessage.textContent = 'Le numéro ne doit contenir que des chiffres';
                      return;
                    }

                    
                    
                    // Check if it starts with 08
                    if (/^8/.test(phoneNumber.slice(1))) {
                      e.target.style.border = '2px solid #EF4444';
                      errorMessage.textContent = 'Le numéro ne doit pas commencer avec 08';
                      return;
                    }
                    
                    // Check length (must be exactly 10 digits)
                    if (phoneNumber.length !== 10) {
                      e.target.style.border = '2px solid #EF4444';
                      errorMessage.textContent = 'Le numéro doit contenir exactement 10 chiffres';
                      return;
                    }
                    

                    // Valid input
                    setIsValidNumber(true);
                    e.target.style.border = '2px solid #10B981';
                    submitButton.disabled = false;
                  }}
                />
              <button id="submit-button" disabled={!isValidNumber} tw="flex text-base items-center justify-center lg:mx-0 h-[80%] px-6 py-2 box-border rounded bg-primary-500 text-gray-100 font-bold hocus:bg-primary-700 hocus:text-gray-200 focus:shadow-outline border-b-0 max-sm:text-xs max-sm:p-2  disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-400 disabled:hover:bg-gray-400" type="submit" form="formulaire-appelle-moi">Parler à un conseiller</button>
              </div>
              <div id="error-message" tw="text-red-500 text-sm mt-2"></div>
            </form>}
            <span tw="font-medium text-lg text-secondary-400">Ou contactez <span  tw="bg-gray-100 transform -skew-x-12 inline-block font-bold text-secondary-500">Impôts Réduc'</span> directement au <a href="tel:+33485696407" tw="bg-gray-100 transform inline-block font-bold text-secondary-500">04.85.69.64.07</a></span>
            <MessageAnimation 
              message="Demande de rappel reçue. Un conseiller vous contactera dans un délai de 48 heures. A bientôt!"
              hasSentMessage={hasSentPhone}
            />
          </div>}
        primaryButtonText="Order Now"
        primaryButtonUrl="https://order.now.com"
        imageInsideDiv={false}
        imageSrc={defiscaliserImageSrc}
        imageCss={Object.assign(tw`bg-cover`, imageCss)}
        imageContainerCss={tw`md:w-1/2 h-auto max-md:order-last`}
        imageDecoratorBlob={true}
        imageDecoratorBlobCss={tw`left-1/2 md:w-32 md:h-32 -translate-x-1/2 opacity-25`}
      />

      </section>
    
      {/* <DownloadApp
        text={<>People around you are ordering delicious meals using the <HighlightedTextInverse>Treact App.</HighlightedTextInverse></>}
      /> */}

      <section tw="my-10">
        <SectionHeading>Nos <HighlightedText>Partenaires</HighlightedText></SectionHeading>
        <p tw="mt-4 mb-6 text-center max-md:text-left text-base md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100">Tous nos partenaires-experts en fiscalité sont signataires de notre charte qualité et certifiés par :</p>
        <div tw="flex flex-wrap justify-center gap-[20%]">
          <img src={anacofiImageSrc} alt="anacofi logo" tw="w-[25%] min-w-[300px] max-md:w-[75%]"/>
          <img src={oriasImageSrc} alt="orias logo" tw="w-[25%] min-w-[300px] max-md:w-[75%]"/>
        </div>
      </section>
    </AnimationRevealPage>
  );
}
